<template>
    <v-app>
        <div class="card card-custom">
            <div class="card-body p-0">
                <div
                        class="wizard wizard-2"
                        id="kt_wizard_v2"
                        data-wizard-state="step-first"
                        data-wizard-clickable="true"
                >
                    <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">

                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12">
                                <h3>
                                    Students
                                </h3>
                                <router-link :to="{name:'dashboard'}">
                                    Dashboard
                                </router-link>
                                \
                                Students
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 text-right mb-3">

                            </div>


                        </div>
                        <div class="row">

                            <form @submit.prevent="getAssignedStudents" class="row  mt-5 bg-filter">

                                <div class="col-md-4 col-6 ">
                                    <v-text-field
                                            label="Firstname, Lastname, CRN number"
                                            outlined
                                            dense
                                            v-model="search.name"
                                    >

                                    </v-text-field>
                                </div>

                                <div class="col-md-4 col-6 ">
                                    <v-select label="Class"
                                              :loading="loading"
                                              outlined dense
                                              :items="academic_classes"
                                              item-text="display_title"
                                              item-value="id"
                                              v-model="search.class_id"></v-select>
                                </div>
                                <div class="col-md-2 col-6 ">
                                    <v-select label="Order by" outlined dense :items="sort_by" item-text="title"
                                              item-value="value"
                                              v-model="search.sort_by"></v-select>
                                </div>
                                <!--                                <div class="col-md-2 col-6 ">-->
                                <!--                                    <v-select label="Status" outlined dense :items="active_statuses" item-text="title"-->
                                <!--                                              item-value="value"-->
                                <!--                                              v-model="search.active"></v-select>-->
                                <!--                                </div>-->
                                <div class="col-md-2 col-6 ">
                                    <button class="btn btn-primary" @click="getAssignedStudents">Filter</button>
                                    <button class="btn btn-standard ml-2" @click="resetFilter">Reset</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row" v-if="loading">
            <div class="col-md-12">
                <v-skeleton-loader
                        v-bind="attrs"
                        type="table"
                ></v-skeleton-loader>

            </div>
        </div>
        <div class="row" v-if="!loading && assigned_students.length>1">
          <div  class="col-md-12 mt-3">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items-per-page="perPage"
                hide-default-footer
                :items="assigned_students"
            >
              <template v-slot:item.thumbnail="{ item }">
                <div class="symbol-label">
                  <img v-if="item.photo" :src="item.image_path.thumb" class="cursor-pointer"
                       alt=""
                       style="height: 30px;">
                  <span v-else class="symbol symbol-35 symbol-light-success">
                                                      <span
                                                          class="symbol-label font-size-h5 font-weight-bold cursor-pointer"
                                                      >
                                                          {{item.full_name.charAt(0)}} </span>
                                                  </span>
                </div>
              </template>
              <template v-slot:item.full_name="{ item }">
                <strong>
                  {{ item.full_name }}
                </strong>
              </template>
              <template v-slot:item.setting.symbol_no="{ item }">
                {{ item.setting ? item.setting.symbol_no : "N/A" }}
              </template>
              <template v-slot:item.is_active="{ item }">
                                                  <span
                                                      :class="item.is_active?'badge badge-success':'badge badge-danger'">{{
                                                      item.is_active ? 'Active' : 'Inactive'
                                                    }}</span>
              </template>


            </v-data-table>
            <b-pagination
                v-if="total>0"
                @input="getAssignedStudents"
                v-model="page"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="text-right p-5"
            ></b-pagination>
          </div>
        </div>
        <div class="row mt-2" v-if="!loading && assigned_students.length<1">
            <div class="col-md-12 text-center">
                <v-card class="p-20">
                    <img src="@/assets/media/images/no-data-found.png">
                    <h5 class="mt-10">No Students available</h5>
                </v-card>
            </div>
        </div>
    </v-app>
</template>

<script>
    import GeneralMixin from "@/mixins/GeneralMixin";

    import AcademicClassService from "@/core/services/academic-class/AcademicClassService";

    const academicClassService = new AcademicClassService();
    export default {
        name: "class-summary-students",
        mixins: [GeneralMixin],

        data() {
            return {
                assigned_students: [],
                loading: false,
                attrs: false,
                headers: [
                    {
                        text: 'Image',
                        align: 'start',
                        filterable: false,
                        sortable: false,
                        value: 'thumbnail'
                    },
                    {text: 'Full Name', value: 'full_name', filterable: true, sortable: true},
                    {text: 'CRN', value: 'personal_id', filterable: true, sortable: true},
                    {text: 'Program', value: 'setting.program_title', filterable: true, sortable: true},
                    {text: 'Level', value: 'setting.current_semester_title', filterable: true, sortable: true},
                    {text: 'Class', value: 'setting.current_class_title', filterable: true, sortable: true},
                    {text: 'Contact', value: 'phone', filterable: true, sortable: true},
                    {text: 'Status', value: 'is_active', filterable: false, sortable: true},
                ],
                search: {
                    active: "active",
                    name: null,
                    crn: null,
                    class_id: null,
                },
                active_statuses: [
                    {title: 'Active', value: "active"},
                    {title: 'In Active', value: "in_active"}
                ],
                sort_by: [
                    {title: 'A-Z', value: "asc"},
                    {title: 'Z-A', value: "desc"}
                ],
                page: null,
                total: 0,
                perPage: 25
            }
        },
        methods: {
            getAssignedStudents() {
                this.loading = true;
                academicClassService.getAllStudents(this.search,this.page).then(response => {
                    this.assigned_students = response.data.data;
                    this.page = response.data.meta.current_page;
                    this.total = response.data.meta.total;
                    this.perPage = parseInt(response.data.meta.per_page);
                }).finally(() => {
                    this.loading = false;
                });
            },
            resetFilter() {
                this.search = {
                    active: "active",
                    name: null,
                    crn: null,
                    class_id: null,
                }
            }
        },
        mounted() {
            this.getAssignedStudents();
            this.getAssignedTeacherCourses();
            this.getAcademicClasses();
        }
    }
</script>

<style scoped>

</style>
